import * as React from "react";
import { useState, useEffect } from "react";
import "rsuite/dist/rsuite.css";
import { Helmet } from "react-helmet-async";
import TablePaginationActions from "../../../common/components/pagination.actions";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
  TablePagination,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  useTheme,
  TableCell,
  Checkbox
} from "@mui/material";
import ProgressLoader from "../../../common/components/progress.loader";
import { useGetPerseusPayOnboardedDealersQuery } from "../../../services/API/surchargeApiSlice";
import { toast } from "react-toastify";
import EnhancedTableHead from "../../../common/components/enhancedtable/enhancedtablehead";
import { Link } from "react-router-dom";

const DealerList = () => {
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  // filters
  const [searchText, setSearchText] = useState("");
  const [dealersList, setDealersList] = React.useState<any>([]);
  const [sortField, setSortField] = React.useState<any>("DateSetup");
  const [sortOrder, setSortOrder] = React.useState<any>("desc");

  const columns = [
    {
      label: "Dealer ID",
      accessor: "dealerId",
      sortable: true,
      display: "table-cell"
    },
    {
      label: "DMS Dealer ID",
      accessor: "dmsDealerId",
      sortable: true,
      display: "table-cell"
    },
    {
      label: "Dealer Name",
      accessor: "dealerName",
      sortable: true,
      display: "table-cell"
    },
    {
      label: "Merchant",
      accessor: "merchantId",
      sortable: true,
      display: "table-cell"
      },
      {
          label: "Country",
          accessor: "countryCode",
          sortable: true,
          display: "table-cell"
      },
    // {
    //   label: "Surcharge Enabled",
    //   accessor: "isSurchargeEnabled",
    //   sortable: false,
    //   display: "table-cell"
    // },
    {
      label: "Onboarding Status",
      accessor: "dealerOnboardingStatus",
      sortable: true,
      display: "table-cell"
    },
    {
      label: "Action",
      accessor: "",
      sortable: false,
      //align: "center",
      display: "table-cell"
    }
  ];

  const { data, isFetching } = useGetPerseusPayOnboardedDealersQuery(
    {
      page: page + 1,
      pageSize: rowsPerPage,
      sortField: sortField,
      sortDirection: sortOrder,
      searchText: searchText
    },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (data) {
      if (data.length === 0 && !isFetching)
        toast.warning("No Perseus Pay Dealer available");

      setDealersList(data);
    }
  }, [data, isFetching]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = e => {
    setSearchText(e.target.value);
  };

  const handleSorting = (sortField, sortOrder) => {
    setSortField(sortField);
    setSortOrder(sortOrder);
  };

  return (
    <>
      <Helmet>
        <title> Dealers | {theme.browserTitle} </title>
      </Helmet>
      <Box>
        <Box>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
          >
            <Typography
              variant="h6"
              gutterBottom
              style={{ fontWeight: "bold" }}
            >
              Dealers
            </Typography>
            <Stack direction="row" alignItems="center">
              <TextField
                id="outlined-search"
                placeholder="Search"
                sx={{ width: "300px" }}
                size="small"
                value={searchText}
                onChange={handleSearchChange}
                //onKeyDown={handleSearchKeyPress}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Stack>
          </Stack>
        </Box>
        <Box component={Paper}>
          {isFetching ? (
            <>
              <TableContainer sx={{ height: "80vh" }}>
                <Table size="small" className="sticky-header sortable">
                  <EnhancedTableHead
                    columns={columns}
                    handleSorting={() => {}}
                    currentSortField=""
                    currentSortOrder=""
                  />
                </Table>
              </TableContainer>
              <Box
                sx={{
                  position: "absolute",
                  zIndex: "5",
                  top: "30%",
                  left: "50%",
                  height: "68vh"
                }}
              >
                <ProgressLoader isFetching={isFetching}></ProgressLoader>
              </Box>
            </>
          ) : (
            <Box>
              <TableContainer
                sx={{ height: "76vh" }}
                style={{ overflow: "auto", scrollbarWidth: "thin" }}
              >
                <Table size="small" className="sticky-header sortable">
                  <EnhancedTableHead
                    columns={columns}
                    handleSorting={handleSorting}
                    currentSortField={sortField}
                    currentSortOrder={sortOrder}
                  />
                  <TableBody>
                    {!dealersList || dealersList?.data?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9}>No record found.</TableCell>
                      </TableRow>
                    ) : (
                      dealersList?.data?.map((row: any, index) => (
                        <TableRow key={index}>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ width: "170px" }}
                          >
                            {row.dealerId}
                          </TableCell>
                          <TableCell align="left">{row.dmsDealerId}</TableCell>
                          <TableCell align="left">{row.dealerName}</TableCell>
                          <TableCell align="left">{row.merchantId}</TableCell>
                          <TableCell align="left">{row.countryCode}</TableCell>
                          {/* <TableCell align="left">
                            <Checkbox
                              disabled
                              checked={Boolean(row.isSurchargeEnabled)}
                            />
                          </TableCell> */}
                          <TableCell align="left">
                            {row.dealerOnboardingStatus}
                          </TableCell>
                          <TableCell>
                            <Link
                              to="../DealerDetail"
                              state={{ DealerSummary: row }}
                            >
                              Details..
                            </Link>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="end"
                style={{ marginTop: "5px", borderTop: "1px solid #c8c8c8" }}
              >
                <Table>
                  <TableBody>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[10, 15, 25, 50]}
                        count={dealersList?.rowCount || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: { "aria-label": "rows per page" },
                          native: true
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default DealerList;
